import { SyntheticEvent } from "react";
import { creditsList, useWebinarStore } from "../hooks/useWebinars";

const CreditsFilter = () => {
  const credits = useWebinarStore((state) => state.credits);
  const addCreditToFilter = useWebinarStore((state) => state.addCreditToFilter);
  const removeCreditFromFilter = useWebinarStore(
    (state) => state.removeCreditFromFilter
  );

  const handleTopicChange = (
    e: SyntheticEvent<HTMLInputElement>,
    credit: number
  ) => {
    const checked = (e.target as any).checked;

    if (checked) {
      addCreditToFilter(credit);
    } else {
      removeCreditFromFilter(credit);
    }
  };
  return (
    <div className="tw-flex tw-flex-col">
      <h3 className="tw-text-lg tw-mb-2 tw-font-medium">Credits</h3>
      <ul className="tw-pl-4 tw-grid tw-grid-cols-4 tw-gap-1">
        {creditsList.map((credit, idx) => (
          <li key={idx}>
            <label
              htmlFor={`credit-${credit}`}
              className="tw-select-none tw-flex tw-items-center tw-gap-x-2 tw-cursor-pointer"
            >
              <div className="tw-flex tw-items-center tw-h-5">
                <input
                  id={`credit-${credit}`}
                  type="checkbox"
                  className="focus:tw-ring-indigo-500 tw-h-4 tw-w-4 tw-text-indigo-600 tw-border-gray-300 tw-rounded tw-cursor-pointer"
                  checked={credits.has(credit)}
                  onChange={(e) => handleTopicChange(e, credit)}
                />
              </div>
              <span>{credit === 8 ? "8+" : credit}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CreditsFilter;
